/** Register optional theme components only when their elements are present.
 * Native cart, product forms, selectors, galleries and drawers remain unchanged.
 * The observer also supports quick-add and Shopify Section Rendering insertions.
 */
const config = document.getElementById('patoume-optional-components');
if (config && !window.patoumeOptionalComponentsStarted) {
  window.patoumeOptionalComponentsStarted = true;
  const pending = new Map(JSON.parse(config.textContent).map((entry) => [entry.tag, entry.url]));
  const observer = new MutationObserver((records) => {
    const added = new Set();
    for (const record of records) {
      for (const node of record.addedNodes) {
        if (node instanceof Element) added.add(node);
      }
    }
    for (const node of added) inspect(node);
  });

  function inspect(root) {
    for (const [tag, url] of pending) {
      if ((root instanceof Element && root.matches(tag)) || root.querySelector(tag)) {
        pending.delete(tag);
        import(url).catch((error) => {
          console.error('[Patoume] Optional component could not load:', tag, error);
        });
      }
    }
    if (pending.size === 0) observer.disconnect();
  }

  function start() {
    observer.observe(document.documentElement, { childList: true, subtree: true });
    inspect(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }
}
